// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3NhXu","rootNoMargin":"styles_rootNoMargin__2rJ9j"};